module.exports = __webpack_public_path__ + "static/antifragile-6d7dad2619c58baaa033519b650f2849.jpg";